<template>
  <div
    :class="dropUp ? 'autocomplete2' : 'autocomplete'"
    ref="autocomplete"
    :id="'select_' + selectId"
    @mouseenter="mouseEnter"
    @mouseleave="mouseLeave"
    :data-cy="CY"
  >
    <div
      class="autocomplete__box"
      :class="{ autocomplete__searching: showResults }"
    >
      <div class="display-grid">
        <label ref="icon" v-if="icon" style="margin-top: 14px">
          <!-- <i :class="icon + ' color-black'"></i> -->
          <img class="custom-icon" :src="getFieldIcon(icon)" alt="" />
        </label>
        <label
          :class="icon ? 'padding-left' : ''"
          ref="label"
          @click="labelClick"
          >{{ label }}<span v-if="required">*</span></label
        >
        <label
          :class="icon ? 'select-error-text padding-left' : 'select-error-text'"
          >{{ error }}</label
        >
        <label class="arrow-right" :style="widthOfInput" @click="labelClick">

          <!-- <div class="arrow-icon"></div> -->
          <img
            v-if="
             display != null &&
              display !== '' &&
              !disabled &&
              !readonly &&
              clearButtonIcon
            "
            @click="clear"
            src="../assets/close.png"
            class="close-icon"
            :id="'clearButton_' + selectId"
          />
          <img :src="require('../assets/grey-arrow.png')" class="arrow-icon" />
        </label>

        <input
          ref="input"
          v-model="display"
          :placeholder="placeholder"
          :title="display"
          :disabled="disabled"
          :maxlength="maxlength"
          @click="search"
          @input="search"
          @keydown.enter="enter"
          @keydown.tab="enter"
          @keydown.up="up"
          @keydown.down="down"
          @keydown.esc="close"
          @focus="focus"
          @focusout="focusout"
          @blur="blur"
          type="text"
          :autocomplete="autocomplete || editable"
          :readonly="(!autocomplete && !editable) || readonly"
          :style="[
            error ? borderColorRed : '',
            disabled ? borderColorDisabled : '',
          ]"
          :class="border ? 'form-control' : 'form-control no-border'"
        />
        <!-- :class="inputClass" -->
        <input :name="name" type="hidden" :value="value" />
      </div>

      <!-- clearButtonIcon -->
      <span
        v-show="!disabled && !isEmpty && !isLoading && !hasError"
        class="autocomplete__icon autocomplete--clear"
        @click="clear"
      >
        <!-- <span v-if="clearButtonIcon" :class="clearButtonIcon"></span> -->
        <!-- <img v-else src="../assets/close.png" /> -->
      </span>
    </div>

    <ul
      v-show="showResults && !readonly && !dropUp"
      ref="list1"
      :class="
        invertDropdown
          ? 'autocomplete__results_invertDropdown'
          : 'autocomplete__results'
      "
      :style="listStyle1"
      style="padding-left:0px"
    >
      <slot name="results">
        <!-- error -->
        <li
          v-if="hasError"
          class="autocomplete__results__item autocomplete__results__item--error"
        >
          {{ ulError }}
        </li>

        <!-- results -->
        <template v-if="!hasError">
          <div class="autocomplete__results_sec" :style="getHeight">
            <li
              v-if="!noResults && display && autocomplete"
              class="autocomplete__results__item"
            >
              <slot name="firstResult">
                Search Results for <strong>{{ display }}</strong></slot
              >
            </li>
            <li
              v-for="(result, key) in results"
              :key="key"
              @click.prevent="select(result)"
              :data-cy="`SSelect_LI_${key}`"
              class="autocomplete__results__item"
              :class="{ autocomplete__selected: isSelected(key) }"
            >
              <!-- v-html="formatDisplay(result)" -->

              <div class="li-option-for-icon">
                <div v-if="result.itemIcon === 'location'">
                  <img width="20px" style="padding-right: 4px;" :src="require('../assets/location.png')" />
                </div>
                <div v-if="result.itemIcon === 'seaport'">
                  <img width="20px" style="padding-right: 4px;" :src="require('../assets/port.png')" />
                </div>
                <div v-if="result.itemIcon === 'customerLocation'">
                  <img width="20px" style="padding-right: 4px;" :src="require('../assets/flag.png')" />
                </div>
                <div v-if="result.itemIcon === 'private'">
                  <img width="20px" style="padding-right: 4px;"
                    :src="require('../assets/sdt-icons/private.png')"
                  /> style="padding-right: 4px;"
                </div>
                <div v-if="result.itemIcon === 'public'">
                  <img width="20px" style="padding-right: 4px;"
                    :src="require('../assets/sdt-icons/public.png')"
                  />
                </div>
                <div>
                  <div class="format-result">{{ formatDisplay(result) }}</div>
                  <div class="result-subtitle">{{ result.subtitle }}</div>
                </div>
              </div>
            </li>
            <slot name="lastResult"></slot>
          </div>
        </template>
        <!-- no results -->
        <li
          v-if="noResults"
          class="autocomplete__results__item autocomplete__no-results"
        >
          <slot name="noResults">{{
            noResultText ? noResultText : "No Results."
          }}</slot>
        </li>
        <!-- add new item -->
        <!-- <template v-if="!hasError && noResults"> -->
        <template v-if="!hasError && addItem">
          <slot name="addNew"></slot>
          <li
            @click.prevent="addNewClick(placeholder)"
            class="autocomplete__results__item shadow"
          >
            <div class="li-option-for-icon">
              <div>
                <img class="addMarker" :src="require('../assets/addbtn.png')" />
              </div>
              <div>
                <div class="title">{{ addNewData.title }}</div>
                <div class="desc">{{ addNewData.description }}</div>
              </div>
            </div>
          </li>
        </template>
      </slot>
    </ul>
    <ul
      v-show="showResults && !readonly && dropUp"
      ref="list2"
      :class="
        invertDropdown
          ? 'autocomplete__results_invertDropdown'
          : 'autocomplete__results_dropUp'
      "
      :style="listStyle2"
      :key="update"
    >
      <slot name="results">
        <!-- error -->
        <li
          v-if="hasError"
          class="autocomplete__results__item autocomplete__results__item--error"
        >
          {{ ulError }}
        </li>

        <!-- results -->
        <template v-if="!hasError">
          <div class="autocomplete__results_sec" :style="getHeight">
            <li
              v-if="!noResults && display && autocomplete"
              class="autocomplete__results__item"
            >
              <slot name="firstResult">
                Search Results for <strong>{{ display }}</strong></slot
              >
            </li>
            <li
              v-for="(result, key) in results"
              :key="key"
              @click.prevent="select(result)"
              class="autocomplete__results__item"
              :class="{ autocomplete__selected: isSelected(key) }"
            >
              <!-- v-html="formatDisplay(result)" -->

              <div class="li-option-for-icon">
                <div v-if="result.itemIcon === 'location'">
                  <img class="pr-4" :src="require('../assets/location.png')" />
                </div>
                <div v-if="result.itemIcon === 'seaport'">
                  <img class="pr-4" :src="require('../assets/port.png')" />
                </div>
                <div v-if="result.itemIcon === 'customerLocation'">
                  <img class="pr-4" :src="require('../assets/flag.png')" />
                </div>
                <div v-if="result.itemIcon === 'private'">
                  <img
                    class="pr-4"
                    :src="require('../assets/sdt-icons/private.png')"
                  />
                </div>
                <div v-if="result.itemIcon === 'public'">
                  <img
                    class="pr-4"
                    :src="require('../assets/sdt-icons/public.png')"
                  />
                </div>
                <div>
                  <div class="format-result">{{ formatDisplay(result) }}</div>
                  <div class="result-subtitle">{{ result.subtitle }}</div>
                </div>
              </div>
            </li>
            <slot name="lastResult"></slot>
          </div>
        </template>
        <!-- no results -->
        <li
          v-if="noResults"
          class="autocomplete__results__item autocomplete__no-results"
        >
          <slot name="noResults">{{
            noResultText ? noResultText : "No Results."
          }}</slot>
        </li>
        <!-- add new item -->
        <!-- <template v-if="!hasError && noResults"> -->
        <template v-if="!hasError && addItem">
          <slot name="addNew"></slot>
          <li
            @click.prevent="addNewClick(placeholder)"
            class="autocomplete__results__item shadow"
          >
            <div class="li-option-for-icon">
              <div>
                <img class="addMarker" :src="require('../assets/addbtn.png')" />
              </div>
              <div>
                <div class="title">{{ addNewData.title }}</div>
                <div class="desc">{{ addNewData.description }}</div>
              </div>
            </div>
          </li>
        </template>
      </slot>
    </ul>
  </div>
</template>

<script type="text/babel">
import * as JSFunctions from "../Functions/Functions.js";
export default {
  name: "SSelect",
  props: {
    CY: String,
    source: {
      type: [String, Function, Array, Object],
      required: true,
    },
    /**
     * Input placeholder
     */
    placeholder: {
      default: "",
    },
    /**
     * Preset starting value
     */
    initialValue: {
      type: [String, Number],
    },
    /**
     * Preset starting display value
     */
    initialDisplay: {
      type: String,
    },
    /**
     * CSS class for the surrounding input div
     */
    inputClass: {
      type: [String, Object],
    },
    /**
     * To disable the input
     */
    disabled: {
      type: Boolean,
    },
    /**
     * name property of the input holding the selected value
     */
    name: {
      type: String,
    },
    /**
     * api - property of results array
     */
    resultsProperty: {
      type: String,
    },
    /**
     * Results property used as the value
     */
    resultsValue: {
      type: String,
      default: "id",
    },
    /**
     * Results property used as the display
     */
    resultsDisplay: {
      type: [String, Function],
      default: "name",
    },
    /**
     * Callback to format the server data
     */
    resultsFormatter: {
      type: Function,
    },
    /**
     * Whether to show the no results message
     */
    showNoResults: {
      type: Boolean,
      default: true,
    },

    /**
     * Optional clear button show/hide
     */
    clearButtonIcon: {
      type: Boolean,
      default: true,
    },
    /**
     * Optional max input length
     */
    maxlength: {
      type: Number,
    },
    /**
     * Optional max height for results list
     */
    maxHeight: {
      type: String,
      default: "400px",
    },
    addItem: {
      type: Boolean,
      default: false,
    },
    addNew: {
      type: [Object, Function],
    },
    label: String,
    icon: String,
    autocomplete: Boolean,
    editable: Boolean,
    border: {
      type: Boolean,
      default: true,
    },
    error: {},
    readonly: {},

    required: {
      Type: Boolean,
      default: false,
    },

    invertDropdown: {
      type: Boolean,
      default: false,
    },
    noResultText: {
      type: String,
      default: null,
    },
    dropUp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      borderColorRed: {
        "border-color": "var( --text-error-color)",
        outline: "none",
        "box-shadow": "none",
      },
      borderColorDisabled: {
        "border-color": "var( --disable)",
      },
      update: 0,
      value: null,
      display: null,
      results: null,
      selectedIndex: null,
      loading: false,
      isFocussed: false,
      ulError: null,
      selectedId: null,
      selectedDisplay: null,
      eventListener: false,
      notFirstTime: false,
      addNewData: this.addPlaceHolder(this.placeholder),
      // noResultMessage:false,
      showClear: false,
      selectId: JSFunctions.uuid(),
    };
  },
  watch: {
    source: {
      deep: true,
      handler(nv, ov) {
        // console.log(nv,ov,this.source);
        if (this.showResults) {
          this.arrayLikeSearch();
          this.update++;
        }
      },
    },
    "$attrs.value": function (nv, ov) {
      // console.log(nv,ov);
      if (this.editable) {
        this.display = nv;
      }
    },
    initialDisplay: function(nv,ov){
      console.log('new: ', nv)
      console.log('old: ', ov)
      if(nv!=ov){
        this.initialDisplay = nv;
      }
    }
  },
  computed: {
    showResults() {
      // console.log(Array.isArray(this.results), this.hasError)
      return Array.isArray(this.results) || this.hasError;
    },
    noResults() {
      // console.log("is Array : ",Array.isArray(this.results), 'results.length : ',this.results);

      let cmp = Array.isArray(this.results) && this.results.length === 0;
      // console.log('noResults : ',cmp)
      return cmp;
    },
    noResultMessage() {
      // console.log('noResults : ',this.noResults,
      // '!isLoading : ',!this.isLoading,
      // 'isFocussed : ',this.isFocussed,
      // '!hasError : ',!this.hasError,
      // 'showNoResults : ',this.showNoResults);

      let cmp =
        this.noResults &&
        !this.isLoading &&
        this.isFocussed &&
        !this.hasError &&
        this.showNoResults;
      // console.log("noResultsMessage : ",cmp)
      return { cmp };
    },
    isEmpty() {
      return !this.display;
    },
    isLoading() {
      return this.loading === true;
    },
    hasError() {
      return this.ulError !== null;
    },
    listStyle1() {
      if (this.isLoading) {
        return {
          color: "#ccc",
        };
      } else {
        return "";
      }
    },
    listStyle2() {
      if (this.isLoading) {
        return {
          color: "#ccc",
        };
      } else {
        return "";
      }
    },
    widthOfInput() {
      if (this.notFirstTime) {
        // console.log(this.$refs.autocomplete.clientWidth,this.$refs.input.clientWidth)

        return {
          // 'width': '0px',
          right: "16px",
          // "margin-top": "10px"
        };
      } else {
        return "";
      }
    },
    getHeight() {
      return { "max-height": this.maxHeight };
    },
  },
  methods: {
    mouseEnter() {
      if (document.getElementById("clearButton_" + this.selectId)) {
        document.getElementById("clearButton_" + this.selectId).style.display =
          "";
      }
    },
    mouseLeave() {
      if (document.getElementById("clearButton_" + this.selectId)) {
        document.getElementById("clearButton_" + this.selectId).style.display =
          "none";
      }
    },
    search(event) {
      this.selectedIndex = null;
      if (!event) {
        return;
      }
      this.$emit("input-value", event.target.value);
      // if (!this.autocomplete) {
      //   return;
      // }
      switch (true) {
        case Array.isArray(this.source):
          this.down();
          return this.arrayLikeSearch();
        default:
          throw new TypeError();
      }
    },
    emitRequestResultEvent() {
      if (this.results.length === 0) {
        this.$emit("noResults", { query: this.display });
      } else {
        this.$emit("results", { results: this.results });
      }
    },
    /**
     * Search in results passed via an array
     */
    arrayLikeSearch() {
      this.setEventListener();
      if (!this.display) {
        this.results = this.source;
        this.$emit("results", { results: this.results });
        this.loading = false;
        return true;
      }

      if (this.autocomplete) {
        this.results = this.source.filter((item) => {
          return this.formatDisplay(item)
            .toLowerCase()
            .includes(this.display.toLowerCase());
        });
      } else {
        this.results = this.source;
      }
      this.$emit("results", { results: this.results });
      this.loading = false;
      // console.log(this.results);
    },
    /**
     * Select a result
     * @param {Object}
     */
    select(obj) {
      if (!obj) {
        return;
      }
      this.value =
        this.resultsValue && obj[this.resultsValue]
          ? obj[this.resultsValue]
          : obj.id;
      this.display = this.formatDisplay(obj);
      this.selectedDisplay = this.display;
      this.$emit("selected", {
        value: this.value,
        display: this.display,
        selectedObject: obj,
      });
      this.$emit("input", this.value);
      // console.log(this.value);
      this.focus();
      this.close();
    },
    addPlaceHolder(value) {
      // console.log(value);
      if (value) {
        let plc = value;
        // console.log(plc);
        let spl = plc.split(" ");
        plc = "";
        for (let i = 1; i < spl.length; i++) {
          plc += spl[i];
        }
        plc = "Add New " + plc;
        let Obj = {};
        Obj.title = plc;
        Obj.description = "";
        return Obj;
      }
      return "Add New";
    },
    addNewClick(value) {
      // console.log(value)
      let temp = value;
      temp = temp.toLowerCase();
      let temp2 = temp.split(" ");
      temp = "";
      for (let i = 1; i < temp2.length; i++) {
        temp += temp2[i];
        if (i + 1 !== temp2.length) {
          temp += "-";
        }
      }
      // temp = temp.replace(/ /g, "-");
      this.$emit("add-new", true);
      // console.log(temp);
      this.$emit("add-" + `${temp}`, true);
      this.focus();
      this.close();
    },
    /**
     * @param  {Object} obj
     * @return {String}
     */
    formatDisplay(obj) {
      switch (typeof this.resultsDisplay) {
        case "function":
          return this.resultsDisplay(obj);
        case "string":
          if (!obj[this.resultsDisplay]) {
            throw new Error(
              `"${this.resultsDisplay}" property expected on result but is not defined.`
            );
          }
          return obj[this.resultsDisplay];

        default:
          throw new TypeError();
      }
    },
    /**
     * Register the component as focussed
     */
    focus() {
      this.isFocussed = true;
      if (this.border) {
        this.$refs.label.className = "label-focus";
      } else {
        this.$refs.label.className = "label-focus-no-bordered";
      }
      if(this.$refs.list1)
      {this.$refs.list1.style.width = this.$refs.input.clientWidth + "px";}
      if(this.$refs.list2)
      {this.$refs.list2.style.width = this.$refs.input.clientWidth + "px";}
      if (this.icon) {
        this.$refs.input.style.paddingLeft = "40px";
      }
    },
    focusout() {
      this.isFocussed = false;
    },
    /**
     * Remove the focussed value
     */
    blur() {
      this.isFocussed = false;

      // console.log(this.value);
      if (this.$refs.input.value !== "") {
        if (this.icon) {
          if (this.border) {
            this.$refs.label.className = "label-focus padding-left";
          } else {
            this.$refs.label.className = "label-focus-no-bordered padding-left";
          }
        } else {
          if (this.border) {
            this.$refs.label.className = "label-focus";
          } else {
            this.$refs.label.className = "label-focus-no-bordered";
          }
        }
      } else {
        if (this.icon) {
          this.$refs.label.className = " padding-left";
        } else {
          this.$refs.label.className = "";
        }
      }
      if (this.placeholder) {
        this.focus();
      }
    },
    /**
     * Is this item selected?
     * @param {Object}
     * @return {Boolean}
     */
    isSelected(key) {
      return key === this.selectedIndex;
    },
    /**
     * Focus on the previous results item
     */
    up() {
      if (this.selectedIndex === null) {
        this.selectedIndex = this.results.length - 1;
        return;
      }
      this.selectedIndex =
        this.selectedIndex === 0
          ? this.results.length - 1
          : this.selectedIndex - 1;
    },
    /**
     * Focus on the next results item
     */
    down() {
      if (this.selectedIndex === null) {
        this.selectedIndex = 0;
        return;
      }
      this.selectedIndex =
        this.selectedIndex === this.results.length - 1
          ? 0
          : this.selectedIndex + 1;
    },
    /**
     * Select an item via the keyboard
     */
    enter() {
      if (this.selectedIndex === null) {
        this.$emit("nothingSelected", this.display);
        return;
      }
      this.select(this.results[this.selectedIndex]);
      this.$emit("enter", this.display);
    },
    /**
     * Clear all values, results and errors
     */
    clear() {
      this.display = null;
      this.value = null;
      this.results = null;
      this.ulError = null;
      this.$attrs.value = "";
      this.$emit("clear");
    },
    /**
     * Close the results list. If nothing was selected clear the search
     */
    close() {
      if (!this.value || !this.selectedDisplay) {
        this.clear();
      }
      if (this.selectedDisplay !== this.display && this.value) {
        this.display = this.selectedDisplay;
      }
      this.results = null;
      this.ulError = null;
      this.removeEventListener();
      this.$emit("close");
    },
    /**
     * Add event listener for clicks outside the results
     */
    setEventListener() {
      if (this.eventListener) {
        return false;
      }
      this.eventListener = true;
      document.addEventListener("click", this.clickOutsideListener, true);
      return true;
    },
    /**
     * Remove the click event listener
     */
    removeEventListener() {
      this.eventListener = false;
      document.removeEventListener("click", this.clickOutsideListener, true);
    },
    /**
     * Method invoked by the event listener
     */
    clickOutsideListener(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.close();
      }
    },
    getFieldIcon(icon) {
      return require("../assets/" + icon + ".png");
    },
    labelClick() {
      // console.log("LABEL Clicked",this.$refs);
      if (this.$refs.input) {
        this.$refs.input.focus();
        this.$refs.input.click();
      }
    },
  },
  mounted() {
    this.notFirstTime = true;
    this.value = this.$attrs.value;
    this.display = this.initialDisplay
      ? this.initialDisplay
      : this.$attrs.value;
    this.selectedDisplay = this.initialDisplay
      ? this.initialDisplay
      : this.$attrs.value;
    if (this.placeholder || this.display) {
      // console.log(this.$refs);
      this.focus();
      this.search();
      this.enter();
    }
    // console.log(this.selectId)
    // console.log(document.getElementById('select_'+this.selectId))
  },
  created() {
    if (this.addNew === undefined) {
      return;
    }
    if (this.addNew.title !== undefined) {
      if (this.addNew.description === undefined) {
        this.addNew.description = "";
      }
      this.addNewData = this.addNew;
    }
  },
};
</script>

<style lang="scss">
.format-result {
    font-family: "Roboto !important";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
  color: #434343;
}
.result-subtitle {
    font-family: "Roboto !important";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
  color: #272727;
}
label {
  position: absolute;
  font-size: 14px;
  line-height: 1;
  margin-top: 14px;
  margin-left: 16px;
  cursor: text;
  color: var(--brown-grey);
  text-transform: capitalize !important;
}
.label-focus {
  margin-top: -4px;
  margin-left: 8px;
  padding-right: 8px;
  padding-left: 8px;
  background-color: #fff;
  font-size: 10px;
  font-weight: bold;
  line-height: 1.25;
  color: var(--black);
  text-transform: uppercase !important;
}

.autocomplete--clear {
  cursor: pointer;
}

.autocomplete__results_invertDropdown {
  margin: 0;
  padding: 0;
  list-style-type: none;
  width: inherit;
  z-index: 1000;
  position: relative;
  // max-height: 400px;
  // overflow-y: auto;
  // width: 100%;
  color: black;
  font-size: 14px;
  line-height: 1.14;
  box-shadow: 0 5px 50px 0 var(--very-light-pink);
  background-color: #fff;
  bottom: 104%;
}

.autocomplete__results {
  margin: 0;
  padding: 0;
  list-style-type: none;
  width: inherit;
  z-index: 1000;
  position: absolute;
  // max-height: 400px;
  // overflow-y: auto;
  // width: 100%;
  color: black;
  font-size: 14px;
  line-height: 1.14;
  box-shadow: 0 5px 50px 0 var(--very-light-pink);
  background-color: #fff;
}
.autocomplete__results_sec {
  overflow-y: auto;
}
.autocomplete__results__item--error {
  color: red;
}

.autocomplete__results__item {
  //   padding: 7px 10px;

    font-family: "Roboto !important";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: left;
  color: #434343;
  border-bottom: 1px solid #e1e1e1;
  padding: 16px;
  cursor: pointer;
  line-height: 1.14;
  text-transform: capitalize;

  &:hover {
    background: rgba(0, 180, 255, 0.075);
  }

  &.autocomplete__selected {
    background: rgba(0, 180, 255, 0.15);
  }
}

.autocomplete__icon {
  height: 14px;
  width: 14px;
}

.display-grid {
  display: grid;
  position: relative;
}

.animate-spin {
  animation: spin 2s infinite linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.padding-left {
  padding-left: 24px;
}
.no-border {
  border: 0 !important;
  box-shadow: inset 0 0 0 rgba(0, 0, 0, 0) !important;
}
.label-focus-no-bordered {
  background-color: #fff;
  margin-top: -8px;
  margin-left: 8px;
  padding-right: 8px;
  padding-left: 8px;
    font-family: "Roboto !important";
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: #000000;
  text-transform: uppercase !important;
}
.select-error-text {
  position: absolute;
    font-family: "Roboto !important";
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: var(--text-error-color);
  padding-top: 32px;
}
.color-black {
  color: #000000;
}
.li-option-for-icon {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  div {
    img {
      min-width: 12px;
      max-width: 40px;
    }
  }
}
.arrow-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;

  .arrow-icon {
    width: 12px;
    height: 12px;
    position: absolute;
    top: 2px;
    padding-right: 2px;
    margin-right: -7px;
    // transform: rotate(135deg);
    // border-top: 2px solid #e1e1e1;
    // border-right: 2px solid #e1e1e1;
  }

  .close-icon {
    padding-top: 35px;
    padding-left: 15px;
    width: 27px;
    height: 48px;
    position: absolute;
    top: -33px;
    margin-right: 10px;
  }

  img {
    margin-left: 8px;
  }
  // text-align: right;
}
.form-control[readonly] {
  // background-color: #eeeeee;
  opacity: 1;
}

.addMarker {
  min-width: 12px;
  max-width: 16px;
  margin: 10px 18px 10px 10px;
}

.title {
    font-family: "Roboto !important";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}
.desc {
  font-size: 10px;
    font-family: "Roboto !important";
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
}
.form-control {
  padding: 12px 32px 12px 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.shadow {
  box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.075), 0 0 4px rgba(102, 175, 233, 0.6);
  -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.075),
    0 0 4px rgba(102, 175, 233, 0.6);
  padding: 16px 0px 16px 6px !important;
}
.text-transform {
  text-transform: capitalize;
}

.autocomplete__results_dropUp {
  margin: 0;
  padding: 0;
  list-style-type: none;
  width: inherit;
  z-index: 1000;
  position: absolute;
  bottom: 108%;
  // max-height: 400px;
  // overflow-y: auto;
  // width: inherit;
  color: black;
  font-size: 14px;
  line-height: 1.14;
  box-shadow: 0 5px 50px 0 var(--very-light-pink);
  background-color: #fff;
  bottom: 104%;
}



.autocomplete2 {
  position: relative;
}
.pr-4{
  padding-right: 4px
}
</style>
